<template>
    <div class="servicesItem">
        <field
            width="110px"
            margin="0 10px 10px 0"
            label="Service"
            :setInputValue="serviceKey"
            is-readonly
        ></field>
        <v-switch
            class="servicesItemSwitch"
            :input-value="editService.status"
            color="success"
            :label="getLabel"
            @change="onChange($event, serviceKey)"
            :disabled="!isSwitchDisabled"
            hide-details
        ></v-switch>
        <field
            width="145px"
            type="text"
            :label="label"
            placeholder="Enter date"
            :dateValue="assigned_date"
            @updateDate="onDate($event, serviceKey)"
            :is-readonly="!editService.status"
            is-date
        ></field>
        <button class="serviceKeyIcon" type="button" @click="onOpenPopup">
            <svg-sprite icon-id="reset" height="20" width="20"></svg-sprite>
        </button>
    </div>
</template>

<script>

export default {
	name: "ServicesItem",
	props: {
		serviceKey: String,
		isSwitchDisabled: {
			type: Boolean,
			default: () => true
		},
		label: {
			type: String,
			default: () => 'Created date'
		},
		editService: Object
	},
	computed: {
		getLabel() {
			return this.isService ? 'Active' : 'Inactive';
		}
	},
	data: () => ({
		isService: false,
		assigned_date: new Date().toISOString().substr(0, 10),
	}),
	methods: {
		onOpenPopup() {
			this.$emit('updateOpenPopup', this.serviceKey);
		},
		onDate(date, serviceKey) {
			this.assigned_date = date;
			this.$emit('updateServiceKey', {
				...this.editService,
				value: this.isService,
				date,
				serviceKey: serviceKey.toLowerCase()
			});
		},
		onChange(value, serviceKey) {
			this.isService = value;
			this.$emit('updateServiceKey', {
				...this.editService,
				value,
				date: this.assigned_date,
				serviceKey: serviceKey.toLowerCase()
			});
		}
	},
	mounted() {
		const { status, date, date_from } = this.editService;
		this.assigned_date = date_from || date || new Date().toISOString().substr(0, 10);
		this.isService = status;
	}
};
</script>

<style scoped lang="scss">
.serviceKeyIcon {
	color: #19BC38;
}
.servicesItemSwitch {
    margin-top: 0;
    padding-top: 0;
}

.servicesItem {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    &Switch {
        width: 120px;
    }
}

.servicesItem:nth-last-of-type(1) {
    margin-bottom: 0;
}
</style>
